import { type Account, AccountType } from '../dto/account';
import type { Rights } from '../state/account/types';

/**
 * A persona is how an account type is used, never a type of its own.
 *
 * Both of these were written out by hand in five places and had already begun
 * to disagree - one of them compared the persona without lowercasing it. The
 * check belongs in one place because the answer decides which product a
 * customer sees.
 */
const personaIs = (rights: Rights | undefined, account: Account | undefined, persona: string): boolean =>
  rights?.accountType === AccountType.Client && (account?.persona ?? '').toLowerCase() === persona;

/** A general or trade contractor: a Client account that builds its own estimates. */
export const isContractorPersona = (rights?: Rights, account?: Account): boolean =>
  personaIs(rights, account, 'contractor');

/** An agency or city running a capital program across departments. */
export const isEnterprisePersona = (rights?: Rights, account?: Account): boolean =>
  personaIs(rights, account, 'enterprise');
